import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['splitSection', 'repeatSection', 'repeatLimitField']

  get repeatCheckbox() {
    return this.element.querySelector('[name$="[repeat]"]')
  }

  get splitAmountInput() {
    return this.element.querySelector('[name$="[split_amount]"]')
  }

  toggleRepeat() {
    const repeatChecked = this.repeatCheckbox?.checked ?? false
    const hasSplit = parseInt(this.splitAmountInput?.value ?? '0') >= 2

    this.splitSectionTarget.classList.toggle('hidden', repeatChecked)
    this.repeatSectionTarget.classList.toggle('hidden', hasSplit)
    this.repeatLimitFieldTarget.classList.toggle('hidden', !repeatChecked)
  }

  connect() {
    this.toggleRepeat()
  }
}
